let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iXT9C")).then(() => parcelRequire('e0h9h'));